/**
 * Previously auto-loaded the RP catalog template into Build Team. HWCG create
 * now seeds the roster from the plan's filled roster on Apply Plan, so this
 * no longer replaces the draft. Kept mounted so call sites stay stable.
 */
export function HwcgRosterSeeder() {
  return null;
}
